export function StatusBadge({ status }) {
  const colors = {
    setup: "bg-amber-100 text-amber-700",
    active: "bg-emerald-100 text-emerald-700",
    completed: "bg-slate-100 text-slate-700"
  };

  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${colors[status]}`}>
      {status}
    </span>
  );
}

export function RankBadge({ rank }) {
  const colors = {
    1: "bg-amber-400 text-amber-900",
    2: "bg-slate-300 text-slate-700",
    3: "bg-amber-600 text-white"
  };

  return (
    <span className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-sm font-bold ${colors[rank] || "bg-slate-100 text-slate-600"}`}>
      {rank}
    </span>
  );
}
